<template>
  <div class="row col-6">
    <server-error :error="error" v-if="error !== null"/>
    <div class="col-12 p-0" v-if="paymentLiabilities">

      <template v-for="asset in paymentLiabilities.assetsTotals">
        <!--Asset Components-->
        <template v-if="asset.assetComponentsTotals.length > 1">
          <template v-for="(component, componentIndex) in asset.assetComponentsTotals">
            <div class="b-liabilities__wrap mt-4" :key="componentIndex">
              <div
                class="b-liabilities__title p-2"
              >{{ getAssetName(asset.assetInContractId) }}{{ getAssetComponentName(component.assetComponentName) }}
              </div>
              <template v-for="(liabilityValue, liability, index) in component.liabilities">
                <div class="pt-2 pb-1 px-2 b-liabilities-row" :key="index">
                  <div class="b-liabilities__name">{{ $t(`CONTENT.charts.liability_sum`) }}
                    ({{ getFullCurrency(liabilityValue.currencyRateType) }})
                  </div>
                  <div
                    class="b-liabilities__value"
                  >{{ convertDecimalToStringForChart(liabilityValue.liabilities) }}
                  </div>
                </div>
              </template>
              <div class="pt-2 pb-1 px-2 b-liabilities-row">
                <div class="b-liabilities__name">{{ $t('CONTENT.charts.liability_sum') }}</div>
                <div
                  class="b-liabilities__value"
                >{{ convertDecimalToStringForChart(component.totalLiabilitiesCost) }}
                </div>
              </div>
              <div class="pt-2 pb-1 px-2 b-liabilities-row">
                <div class="b-liabilities__name">{{ $t('CONTENT.charts.asset_component_cost') }}</div>
                <div
                  class="b-liabilities__value"
                >{{ convertDecimalToStringForChart(component.totalCost) }}
                </div>
              </div>
              <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="component.totalLiabilitiesAdjustment !== null">
                <div class="b-liabilities__name">{{ $t('CONTENT.charts.totalLiabilitiesAdjustment') }}</div>
                <div
                  class="b-liabilities__value"
                >{{ convertDecimalToStringForChart(component.totalLiabilitiesAdjustment) }}
                </div>
              </div>
              <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="component.totalAssetComponentAdjustment !== null">
                <div class="b-liabilities__name">{{ $t('CONTENT.charts.totalAssetComponentAdjustment') }}</div>
                <div
                  class="b-liabilities__value"
                >{{ convertDecimalToStringForChart(component.totalAssetComponentAdjustment) }}
                </div>
              </div>
            </div>
          </template>
        </template>
        <!--Asset-->
        <div class="b-liabilities__wrap mt-4" :key="asset.idInDB">
          <div class="b-liabilities__title p-2">{{ getAssetName(asset.assetInContractId) }}</div>

          <template v-for="(liabilityValue, liability, index) in asset.liabilities">
            <div class="pt-2 pb-1 px-2 b-liabilities-row" :key="index">
              <div class="b-liabilities__name">{{ $t(`CONTENT.charts.liability_sum`) }}
                ({{ getFullCurrency(liabilityValue.currencyRateType) }})
              </div>
              <div class="b-liabilities__value">{{ convertDecimalToStringForChart(liabilityValue.liabilities) }}</div>
            </div>
          </template>

          <div class="pt-2 pb-1 px-2 b-liabilities-row">
            <div class="b-liabilities__name">{{ $t('CONTENT.charts.liability_sum') }}</div>
            <div
              class="b-liabilities__value"
            >{{ convertDecimalToStringForChart(asset.totalLiabilitiesCost) }}
            </div>
          </div>
          <div class="pt-2 pb-1 px-2 b-liabilities-row">
            <div class="b-liabilities__name">{{ $t('CONTENT.charts.asset_cost') }}*</div>
            <div class="b-liabilities__value">{{ convertDecimalToStringForChart(asset.totalAssetCost) }}</div>
          </div>
          <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="asset.totalLiabilitiesAdjustment !== null">
            <div class="b-liabilities__name">{{ $t('CONTENT.charts.totalLiabilitiesAdjustment') }}</div>
            <div class="b-liabilities__value">{{ convertDecimalToStringForChart(asset.totalLiabilitiesAdjustment) }}
            </div>
          </div>
          <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="asset.totalAssetAdjustment !== null">
            <div class="b-liabilities__name">{{ $tc('CONTENT.charts.totalAssetAdjustment', 1) }}</div>
            <div class="b-liabilities__value">{{ convertDecimalToStringForChart(asset.totalAssetAdjustment) }}</div>
          </div>
        </div>
      </template>

      <!--Result-->

      <div class="b-liabilities__wrap mt-4">
        <div class="b-liabilities__title p-2">{{ $t('CONTENT.charts.result') }}</div>
        <template v-for="(liabilityValue, liability, index) in paymentLiabilities.liabilities">
          <div class="pt-2 pb-1 px-2 b-liabilities-row" :key="index">
            <div class="b-liabilities__name">{{ $t(`CONTENT.charts.liability_sum`) }}
              ({{ getFullCurrency(liabilityValue.currencyRateType) }})
            </div>
            <div class="b-liabilities__value">{{ convertDecimalToStringForChart(liabilityValue.liabilities) }}</div>
          </div>
        </template>
        <div class="pt-2 pb-1 px-2 b-liabilities-row">
          <div class="b-liabilities__name">{{ $t('CONTENT.charts.liabilities_sum_in_currency_code') }}</div>
          <div
            class="b-liabilities__value"
          >{{ convertDecimalToStringForChart(paymentLiabilities.totalLiabilitiesCost) }}
          </div>
        </div>
        <div class="pt-2 pb-1 px-2 b-liabilities-row">
          <div class="b-liabilities__name">{{ $t('CONTENT.charts.liabilities_asset_sum_in_currency_code') }}</div>
          <div
            class="b-liabilities__value"
          >{{ convertDecimalToStringForChart(paymentLiabilities.totalAssetsCost) }}
          </div>
        </div>
        <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="paymentLiabilities.totalLiabilitiesAdjustment !== null">
          <div class="b-liabilities__name">{{ $t('CONTENT.charts.totalLiabilitiesAdjustment') }}</div>
          <div class="b-liabilities__value">
            {{ convertDecimalToStringForChart(paymentLiabilities.totalLiabilitiesAdjustment) }}
          </div>
        </div>
        <div class="pt-2 pb-1 px-2 b-liabilities-row" v-if="paymentLiabilities.totalAssetsAdjustment !== null">
          <div class="b-liabilities__name">{{ $tc('CONTENT.charts.totalAssetAdjustment', 2) }}</div>
          <div class="b-liabilities__value">
            {{ convertDecimalToStringForChart(paymentLiabilities.totalAssetsAdjustment) }}
          </div>
        </div>
      </div>
      <div class="b-liabilities__note p-2">*{{ $t('CONTENT.charts.initial_recognition_asset_cost') }}</div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PaymentsCalculationsAPI from "../../api/PaymentsCalculationsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";
import getFullCurrency from "../../../../mixins/getFullCurrency";

export default {
  props: {
    liabilitiesErrors: {
      required: false,
    },
    contractId: {
      required: true,
      type: Number | null
    },
    currentVersionId: {
      required: true,
      default: String | null
    },
    isPreview: {
      default: false
    },
    components: {
      type: Array,
      required: true
    },
    allAssets: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      error: null,
      paymentLiabilities: null
    };
  },
  mixins: [getFullCurrency],
  created() {
    this.calculateLiabilitiesAsync();
  },
  watch: {
    async components() {
      await this.calculateLiabilitiesAsync();
    },
    async isEditContract() {
      await this.calculateLiabilitiesAsync();
    }
  },
  computed: {
    ...mapGetters(["getContractState"]),
    isEditContract() {
      return this.getContractState;
    },
    assetNames() {
      const assetNames = {}
      this.allAssets.forEach(a => assetNames[a.idInDB] = a.name)
      return assetNames
    }
  },
  methods: {
    getAssetComponentName(component) {
      if (component.name !== null) {
        return ` - ${component}`;
      }
    },
    getAssetName(assetId) {
      return this.assetNames[assetId]
    },
    async calculateLiabilitiesAsync() {
      this.$fileLoadingManager.startLoading();
      this.error = null;
      try {
        const paymentAPI = new PaymentsCalculationsAPI();
        if (this.isPreview || this.isEditContract) {
          if(this.components.length === 0) return
          this.paymentLiabilities = await paymentAPI.calculateLiabilitiesResultPreview(
            this.components
          );
        } else {
          this.paymentLiabilities = await paymentAPI.calculateLiabilitiesResult(
            this.contractId,
            this.currentVersionId
          );
        }
      } catch (e) {
        this.error = e;
        this.liabilitiesErrors(e);
        console.error(e);
      } finally {
        this.$fileLoadingManager.finishLoading();
      }
    },
    async getCurrencyRate(paymentsParameter, startDate) {
      let encodedStartDate = encodeURIComponent(startDate);
      let currencyRateData = {};

      currencyRateData.onDate = encodedStartDate;
      currencyRateData.type = paymentsParameter.currencyRateParameters.type;
      currencyRateData.currencyCode = paymentsParameter.currencyCode;
      currencyRateData.minValue =
        paymentsParameter.currencyRateParameters.minValue;
      currencyRateData.maxValue =
        paymentsParameter.currencyRateParameters.maxValue;
      currencyRateData.fixedValue =
        paymentsParameter.currencyRateParameters.fixedValue;

      return await this.$store.dispatch("getCurrencyRate", currencyRateData);
    },
    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },
  }
};
</script>
